<template>
  <div class="box" @scroll="handleScroll($event)">
    <Header ref="headerNav" />
    <div class="content">
      <div class="headerbg">
        <span>物流管理教学平台</span>
        <b>LOGISTICS MANAGEMENT PLATFORM</b>
      </div>
      <div class="mainbody">
        <div class="setionbox">
          <p>
            《物流教学模拟平台》设置了原材料供应商、厂商、零售商、贸易公司、第三方物流公司五个角色，主要模拟了厂商采购生产流程，厂商和贸易公司、厂商和零售商之间的交易流程。
          </p>
        </div>
        <div class="setionbox">
          <div class="setion">
            <img style="width:1201px;" src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/LogisticsManagementPlatform/img1.png" alt="">

          </div>
        </div>


      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  name: 'LogisticsManagementPlatform',
  methods:{
     handleScroll (e) {
      if(e.srcElement.scrollTop>2){
        this.$refs.headerNav.showHeadBj()
      }else {
        this.$refs.headerNav.hideHeadBj()
      }
      //滚动事件
    },
  }
}
</script>

<style lang="scss" scoped>
.setionbox:nth-child(odd) {
  background: #f8f8f8;
}

.box {
  width: 100%;
  height: 100%;
  overflow: auto;
  // position: relative;
}
.headerbg {
  width: 100%;
  height: 580px;
  background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/LogisticsManagementPlatform/headerbgi.png");
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  span {
    font-size: 42px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
  b {
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #006cda;
  }
}
.setionbox {
  width: 100%;
  // background-color: red;
  .setion {
    margin: 0 auto;
    width: 1200px;
    padding-top: 80px;
    padding-bottom: 80px;
    // background-color: #f5ff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 150px;

  }
}
.mainbody > .setionbox > p {
  padding-top: 30px;
  padding-bottom: 30px;
  width: 1080px;
  margin: 0 auto;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  background: #f8f8f8;
  text-align: center;
  line-height: 1.8;
}
</style>



// WEBPACK FOOTER //
// src/pages/LogisticsManagementPlatform.vue